import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../lib/api";
import CustomerHeader from "../../components/CustomerHeader";
import { Button } from "../../components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ mode }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState(mode === "cancel" ? "cancelled" : "checking");
  const attempts = useRef(0);
  const orderId = localStorage.getItem("fuma_last_order");

  useEffect(() => {
    if (mode === "cancel") return;
    const sessionId = params.get("session_id");
    if (!sessionId) { setState("error"); return; }
    let stop = false;
    const poll = async () => {
      if (stop) return;
      if (attempts.current >= 8) { setState("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.payment_status === "failed") { setState("failed"); return; }
      } catch {}
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [mode, params]);

  const goTracking = () => orderId ? navigate(`/app/orders/${orderId}`) : navigate("/app/orders");

  const views = {
    checking: { icon: <Loader2 className="h-14 w-14 text-[#00E676] animate-spin" />, title: "Verifica pagamento…", sub: "Attendi qualche secondo." },
    paid: { icon: <CheckCircle2 className="h-14 w-14 text-[#00E676]" />, title: "Pagamento riuscito", sub: "Il tuo ordine è confermato." },
    failed: { icon: <XCircle className="h-14 w-14 text-red-400" />, title: "Pagamento fallito", sub: "Riprova o scegli contanti alla consegna." },
    cancelled: { icon: <XCircle className="h-14 w-14 text-amber-400" />, title: "Pagamento annullato", sub: "L'ordine è stato creato ma non pagato." },
    timeout: { icon: <Loader2 className="h-14 w-14 text-amber-400" />, title: "In elaborazione", sub: "Controlla lo stato nell'ordine tra poco." },
    error: { icon: <XCircle className="h-14 w-14 text-red-400" />, title: "Sessione non valida", sub: "" },
  };
  const v = views[state] || views.checking;

  return (
    <div className="min-h-screen bg-[#0A0A0C] grain">
      <CustomerHeader />
      <main className="max-w-md mx-auto px-4 py-24 text-center relative z-10" data-testid="payment-result">
        <div className="flex justify-center mb-6">{v.icon}</div>
        <h1 className="font-display font-black text-3xl tracking-tighter" data-testid={`payment-state-${state}`}>{v.title}</h1>
        <p className="text-zinc-400 mt-2">{v.sub}</p>
        <Button data-testid="go-to-order" onClick={goTracking} className="mt-8 bg-[#00E676] text-black rounded-full">Vai all'ordine</Button>
      </main>
    </div>
  );
}
